import { dateTimeDiff } from '@components/HelperComponents/HelperComponents';
import { StopMapDTO } from '@model/dashboard/StopMapDTO';
import { formatDateTime } from '@util/date.util';
import { ExtractedStopType } from '@type/dashboard/ExtraxtedStopType';

export const getCommunicationIcon = (plannedNextConnection, t) => {
  const diff = dateTimeDiff(
    plannedNextConnection,
    t('general.day'),
    t('general.hour'),
    t('general.min'),
    t('general.sec'),
    t('general.now'),
  );

  if (!diff.diffMin) {
    return '/design/svg/nincsen.svg';
  }

  if (diff.diffMin <= 2) {
    return '/design/svg/idoben.svg';
  }

  if (diff.diffMin > 2 && diff.diffMin <= 30) {
    return '/design/svg/kesik.svg';
  }

  if (diff.diffMin > 30 && diff.diffMin <= 1440) {
    return '/design/svg/megszakadt.svg';
  }

  return '/design/svg/nincsen.svg';
};

export const extractStops = (fetchedStops: StopMapDTO[], t): ExtractedStopType[] =>
  fetchedStops?.flatMap((item) => {
    return (
      item.terminals.map((terminal) => ({
        ...item,
        ...terminal,
        lastInsertDate: formatDateTime(terminal.insertDate),
        batteryLevel: terminal.batteryLevel
          ? Number(terminal.batteryLevel?.replace('%', ''))
          : 0,
        communication: getCommunicationText(terminal.plannedNextConnection, t),
        terminals: null,
        terminalName: terminal.name,
      })) ?? []
    );
  });

// case insensitive, accents count: "kék" doesn't find "kek" and the other way round
const normalizeSearchText = (text?: string) => (text ?? '').toLocaleLowerCase('hu');

export const filterStopsBySearchText = (
  stops: ExtractedStopType[] | undefined,
  searchText: string,
): ExtractedStopType[] | undefined => {
  const search = normalizeSearchText(searchText.trim());
  if (!search || !stops) {
    return stops;
  }
  return stops.filter(
    (stop) =>
      normalizeSearchText(stop.stopName).includes(search) ||
      normalizeSearchText(stop.terminalName).includes(search),
  );
};

export const getCommunicationText = (plannedNextConnection, t) => {
  const diff = dateTimeDiff(
    plannedNextConnection,
    t('general.day'),
    t('general.hour'),
    t('general.min'),
    t('general.sec'),
    t('general.now'),
  );

  if (!diff.diffMin) {
    return t('stop-terminal-status.stop-table.header.ok-time.nothing');
  }

  if (diff.diffMin <= 2) {
    return t('stop-terminal-status.stop-table.header.ok-time.on-time');
  }

  if (diff.diffMin > 2 && diff.diffMin <= 30) {
    return t('stop-terminal-status.stop-table.header.ok-time.delay');
  }

  if (diff.diffMin > 30 && diff.diffMin <= 1440) {
    return t('stop-terminal-status.stop-table.header.ok-time.break');
  }

  return t('stop-terminal-status.stop-table.header.ok-time.nothing');
};
